import { required, integer, minValue, minLength, helpers } from '@vuelidate/validators';
import i18n from "@/plugins/i18n";

export default function (formState) {
  return {
    form: {
      type: {
        required: helpers.withMessage(i18n.global.t('Order type is required.'), required),
      },
      items: {
        required: helpers.withMessage(i18n.global.t('Please add at least one item to the cart.'), required),
        minLength: helpers.withMessage(i18n.global.t('Please add at least one item to the cart.'), minLength(1)),
        $each: helpers.forEach({
          product_id: {
            required: helpers.withMessage(i18n.global.t('Product is required.'), required),
            integer: helpers.withMessage(i18n.global.t('Please enter a valid number.'), integer),
          },
          quantity: {
            required: helpers.withMessage(i18n.global.t('Quantity is required.'), required),
            integer: helpers.withMessage(i18n.global.t('Please enter a valid number.'), integer),
            minValue: helpers.withMessage(i18n.global.t('Quantity must be at least 1.'), minValue(1)),
          },
          modifier_option_ids: {}
        })
      }
    }
  }
};
